import { twResolve } from "@/helpers/tw-resolve";
import { useTranslation } from "@/translations";

import { Button } from "../../Button/Button";
import { LoadingIcon } from "../../CustomIcons/LoadingIcon";
import { Edit05Icon } from "../../Icons/Edit05Icon";
import { Send03Icon } from "../../Icons/Send03Icon";
import { Tooltip } from "../../Tooltip/Tooltip";

export function CommentFieldSend({
  sendTooltip,
  isSubmitting,
  isEdit,
  canSend,
  onSubmit,
  isReply,
}: {
  sendTooltip?: string;
  isSubmitting?: boolean;
  isEdit?: boolean;
  canSend?: boolean;
  onSubmit: () => Promise<void>;
  isReply?: boolean;
}): React.ReactElement {
  const { t } = useTranslation();
  const onClickSend = () => {
    void onSubmit();
  };

  return isReply ? (
    <Button
      title={sendTooltip || t("component.comment-field.send-comment")}
      className="min-w-fit"
      data-testid="send-comment"
      styling="primary"
      disabled={isSubmitting || !canSend}
      onClick={onSubmit}
      isLoading={isSubmitting}
    >
      {isEdit ? t("component.community-post.comments.edit") : t("component.community-post.comments.reply")}
    </Button>
  ) : (
    <Tooltip tooltip={sendTooltip || t("component.comment-field.send-comment")}>
      <button
        className={twResolve(
          "flex size-7 cursor-pointer items-center justify-center rounded-full transition-colors focus:bg-blue-200 focus:outline-none hover:bg-blue-100 disabled:pointer-events-none",
          canSend ? "text-aop-basic-blue-500" : "opacity-30",
          isSubmitting && "pointer-events-none",
        )}
        data-testid="send-comment"
        disabled={isSubmitting || !canSend}
        type="button"
        onClick={onClickSend}
      >
        {
          // eslint-disable-next-line no-nested-ternary
          isSubmitting ? <LoadingIcon className="w-5" /> : isEdit ? <Edit05Icon size={20} /> : <Send03Icon size={20} />
        }
      </button>
    </Tooltip>
  );
}
